__webpack_require__.p = "https://stockmarket.bditpoint.com/";